var map = {
	"./1000.jpg": 5856,
	"./1002.jpg": 7522,
	"./1003.jpg": 191,
	"./1004.jpg": 3028,
	"./1005.jpg": 6753,
	"./1006.jpg": 8982,
	"./1007.jpg": 7507,
	"./1008.jpg": 4008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7384;